var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSailLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.94 105.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,85.06l13.86-2c.56,7.46,2.35,11.92,9,11.92,5,0,7.6-2.91,7.6-6.92C30.41,79.23,7,69,7,54.57c0-12.1,10.07-18.2,23-18.2,15.09,0,19.56,7.47,20.79,18.84l-14.2,2.73c-.78-7-2.46-10.56-7.71-10.56-3.47,0-6.37,1.92-6.37,5.92,0,8.46,23.36,19.11,23.36,33,0,12.29-10,19.29-23.59,19.29C4.92,105.62.78,96.8,0,85.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.68,18.25A282.36,282.36,0,0,0,12.34,28.64C16,11.58,30,3.86,36,2.37c.62.14,4.85,1,9.7,5.93A52.42,52.42,0,0,1,52.68,18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.94,30.94A109.46,109.46,0,0,1,69.18,69a109.53,109.53,0,0,0-13.71-52A53,53,0,0,0,48.53,7c-4.86-4.92-9.09-5.79-9.71-5.93l-.07,0a26.92,26.92,0,0,1,8.19-1C58.34.14,86.71,7.67,103.94,30.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSailLogoWhite);
export default __webpack_public_path__ + "static/media/sailLogoWhite.6ad0ad72a50f0dc95e0662538f3b9ee6.svg";
export { ForwardRef as ReactComponent };